import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_KIEMTRANOXAU } from "actions/KiemTraNoXau/actionTypes";
import {
  getListKiemTraNoXauSuccess,
  getListKiemTraNoXauFailure,
} from "actions/KiemTraNoXau";
import KiemTraNoXauApi from "service/danhSachKhachHangApi";
import { pushNotification } from "utils/notifications";

function* getListKiemTraNoXau(action) {
  try {
    const response = yield call(KiemTraNoXauApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListKiemTraNoXauSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListKiemTraNoXauFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListKiemTraNoXauFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_KIEMTRANOXAU, getListKiemTraNoXau);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
